import { MusicXmlTest } from "./apps/MusicXmlTest.js";
import { MainApp } from "./apps/MainApp.js";

export class Application {

    constructor(private _element: HTMLDivElement) {
        e5.console.log("[eventfive.signum.emoji] [Application]");

        this.init();
    }

    private async init() {
        const isRuntime = Boolean(window.api);
        const debug = e5.console.enabled || e5.Url.params.has("debug");
        e5.console.enabled = debug;
        
        let assetsUrl = this._element.getAttribute("data-base") + "/assets";

        new MainApp({
            element: this._element,
            assetsUrl: assetsUrl
        });

        // new MusicXmlTest({
        //     element: this._element,
        //     assetsUrl: assetsUrl
        // });
    }
}

document.addEventListener("DOMContentLoaded", () => {
    var e = document.querySelector<HTMLDivElement>("#app");
    if (e) {
        new Application(e);
    }
});